import React from "react";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import CustomizationColorPickingRow, {
  ColorPickingRowEnum,
} from "../helpers/CustomizationColorPickingRow";
import CustomizationBorderRadiusRow, {
  BorderRadiusFieldEnum,
} from "../helpers/CustomizationBorderRadiusRow";

const ConfigurationButtonColorsCard = () => {
  return (
    <ConfigurationSettingsCard title="Button styling">
      <div className="flex flex-col justify-between gap-4">
        <div className="mb-1">Customize the primary button styling on all applicable screens</div>
        <CustomizationColorPickingRow type={ColorPickingRowEnum.TEXT_COLOR} />
        <CustomizationColorPickingRow type={ColorPickingRowEnum.BUTTON_COLOR} />
        <CustomizationBorderRadiusRow
          type={BorderRadiusFieldEnum.BUTTON}
          label="Border radius"
          className="font-semibold"
        />
      </div>
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationButtonColorsCard;
